import React, { useCallback, useMemo, useState } from "react";
import placeholderImg from "../images/placeholder.png";
import GalleryProduct from "./gallery-product";
import GalleryModal from "./gallery-modal";

const SliderImgProdotto = ({
  data,
  labelManagerLabels,
  bannerPromoCM,
  badge,
  enhanced = false,
  origin,
  pagePath,
}) => {
  const {
    productName,
    productVideo,
    url360,
    otherImages,
    s3Images,
    primaryThumb,
    primaryMedium,
    primaryFull,
    s3Thumb,
    s3Medium,
    s3Full,
    otherThumb,
    otherMedium,
    otherFull,
    familiesIds,
    key_prod,
  } = data;
  const imgTitle = `${productName} ${key_prod}`;

  const youtubeId = useMemo(() => {
    // Video del prodotto, fallback su video famiglia
    const video = productVideo
      ? productVideo
      : familiesIds.length && familiesIds[0].video
      ? familiesIds[0].video
      : null;
    return video ? video.split("/").reverse()[0] : null;
  }, [familiesIds, productVideo]);
  // const offset = youtubeId ? 1 : 0 + (url360 ? 1 : 0);

  const s3SlidesData = useMemo(
    () =>
      enhanced
        ? s3Images.map((_full, i) => ({
            thumb: s3Thumb[i]?.find((item) => item.imageType === "640") || placeholderImg,
            medium: s3Medium[i]?.find((item) => item.imageType === "640") || placeholderImg,
            full: s3Full[i]?.find((item) => item.imageType === "M") || placeholderImg,
            title: imgTitle,
            s3Images: true,
          }))
        : [],
    [enhanced, s3Images, s3Full, s3Medium, s3Thumb, imgTitle]
  );

  const slidesData = useMemo(() => {
    return [
      {
        thumb: primaryThumb?.find((item) => item.imageType === "640") || placeholderImg,
        medium: primaryMedium?.find((item) => item.imageType === "640") || placeholderImg,
        full: primaryFull?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
      },
    ].concat(
      otherImages
        ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
        .map((_full, i) => ({
          thumb:
            otherThumb
              ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
              ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
          medium:
            otherMedium
              ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
              ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
          full:
            otherFull
              ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
              ?.[i]?.find((item) => item.imageType === "M") || placeholderImg,
          title: imgTitle,
        }))
    );
  }, [
    otherImages,
    primaryThumb,
    primaryMedium,
    primaryFull,
    otherThumb,
    otherMedium,
    otherFull,
    imgTitle,
  ]);

  const primarySlidesData = useMemo(() => {
    return [
      {
        thumb: primaryThumb?.find((item) => item.imageType === "640") || placeholderImg,
        medium: primaryMedium?.find((item) => item.imageType === "640") || placeholderImg,
        full: primaryFull?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
      },
    ];
  }, [primaryThumb, primaryMedium, primaryFull, imgTitle]);

  const otherSlidesData = useMemo(() => {
    return otherImages
      .filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
      .map((_full, i) => ({
        thumb:
          otherThumb
            ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        medium:
          otherMedium
            ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        full:
          otherFull
            ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
      }));
  }, [otherFull, otherImages, otherMedium, otherThumb, imgTitle]);

  const designSlidesData = useMemo(() => {
    return otherImages
      .filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
      .map((_full, i) => ({
        thumb:
          otherThumb
            ?.filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        medium:
          otherMedium
            ?.filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        full:
          otherFull
            ?.filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
        dimensions: true,
      }));
  }, [otherFull, otherImages, otherMedium, otherThumb, imgTitle]);

  const isFirstImageS3Present =
    s3SlidesData?.length > 0 && !s3Images?.find((image) => image?.[0]?.imageUrl?.includes("_000."));

  const url360Slide = url360
    ? {
        ...slidesData[0],
        url360,
      }
    : null;
  const youtubeSlide = youtubeId
    ? {
        ...slidesData[0],
        youtubeId,
      }
    : null;

  const allSlidesData = (
    isFirstImageS3Present
      ? primarySlidesData.concat(s3SlidesData).concat(otherSlidesData)
      : s3SlidesData.concat(slidesData)
  )
    .concat(url360Slide)
    .concat(designSlidesData)
    .concat(youtubeSlide)
    .filter(Boolean);

  const [zoomIdx, setZoomIdx] = useState(-1);
  const showZoom = useCallback((e) => {
    const index = parseInt(e.currentTarget.name);
    setZoomIdx(index);
  }, []);
  const closeZoom = () => setZoomIdx(-1);

  return (
    <div>
      <GalleryProduct
        slides={allSlidesData}
        badge={badge}
        enhanced={enhanced}
        labelManagerLabels={labelManagerLabels}
        showZoom={showZoom}
        bannerPromoCM={bannerPromoCM}
        pagePath={pagePath}
      />
      <GalleryModal
        allSlidesData={allSlidesData}
        enhanced={enhanced}
        labelManagerLabels={labelManagerLabels}
        showZoom={showZoom}
        zoomIdx={zoomIdx}
        closeZoom={closeZoom}
        key={`${zoomIdx >= 0}`}
        pagePath={pagePath}
      />
    </div>
  );
};

export default SliderImgProdotto;
